module.exports = __webpack_public_path__ + "img/model_71.5a1cfc24.png";